// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import 'wowjs/css/libs/animate.css'
import '../static/assets/sass/style.scss'
import { WOW } from 'wowjs'
import { sync } from 'vuex-router-sync'
import BaiduMap from 'vue-baidu-map'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
import '../node_modules/swiper/dist/css/swiper.css'
Vue.use(BaiduMap, {
  ak: 'PYzlYi6HlHLtacv40lYNQLy9YaVEBkHr'
})

new WOW({live: false}).init()
sync(store, router)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js